import { PureComponent } from 'react';
import { shape, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { setHeadlineBackButtonConfig } from '~/ocab-services/services.actions';
import { routeConfigSelectors } from '~/ocab-services/route-config.selectors';
import { getTokenFromStorage } from '~/components/persist-token/persist-token.utils';
import { appointmentDraftSelectors, journeyStateSelectors } from '~/api';
import { routerSelectors } from '~/selectors';
import { errorMessagesActions } from '../messages';

export const withHeadlineBackButton = (title, defaultPrevPath) => (Component) =>
  class ComponentWithHeadlineBackButton extends PureComponent {
    static propTypes = {
      history: shape({}).isRequired,
      location: shape({}).isRequired,
      prevPathConfig: shape({}).isRequired,
      selectedShop: shape({}).isRequired,
      isHeadlineBackButtonDisplayed: bool,
      dispatchSetHeadlineBackButtonConfig: func.isRequired,
      dispatchClearOnlyErrorMessages: func.isRequired,
      dispatchTryAgainClicked: func.isRequired,
    };

    static defaultProps = {
      isHeadlineBackButtonDisplayed: false,
    };

    componentDidMount() {
      const {
        location: { hash },
      } = this.props;

      if (!hash) {
        this.setHeadlineBackButtonConfig();
      }
    }

    componentDidUpdate() {
      const {
        location: { hash },
        isHeadlineBackButtonDisplayed,
      } = this.props;

      if (!hash && !isHeadlineBackButtonDisplayed) {
        this.setHeadlineBackButtonConfig();
      }
    }

    setHeadlineBackButtonConfig = (additionalConfig) => {
      const { prevPathConfig = {}, dispatchSetHeadlineBackButtonConfig, selectedShop } = this.props;

      let prevPath = prevPathConfig.prevPath || defaultPrevPath;

      if (prevPath instanceof Function) {
        prevPath = prevPath(selectedShop.shortName);
      }

      dispatchSetHeadlineBackButtonConfig({
        isDisplayed: true,
        title: prevPathConfig.title || title,
        goBack: prevPath.includes('#') ? this.pushBackWithHash(prevPath) : this.pushBack(prevPath),
        ...additionalConfig,
      });
    };

    pushBack = (prevPath) => () => {
      const { history, dispatchClearOnlyErrorMessages, dispatchTryAgainClicked } = this.props;

      dispatchClearOnlyErrorMessages();
      dispatchTryAgainClicked(false);
      return history.pushWithToken(prevPath);
    };

    pushBackWithHash = (prevPath) => () => {
      const { history, dispatchClearOnlyErrorMessages, dispatchTryAgainClicked } = this.props;

      dispatchClearOnlyErrorMessages();
      dispatchTryAgainClicked(false);
      const hash = prevPath.split('#')[1];
      return history.push(
        `/shops${getTokenFromStorage() ? `?token=${getTokenFromStorage()}#${hash}` : `#${hash}`}`,
      );
    };

    render() {
      return <Component {...this.props} />;
    }
  };

export const mapStateToProps = (state) => ({
  location: routerSelectors.selectLocation(state),
  isHeadlineBackButtonDisplayed:
    routeConfigSelectors.selectHeadlineBackButtonConfig(state).isDisplayed,
  prevPathConfig: journeyStateSelectors.selectPathConfigForPage(state),
  selectedShop: appointmentDraftSelectors.selectShop(state),
});

const mapDispatchToProps = {
  dispatchSetHeadlineBackButtonConfig: setHeadlineBackButtonConfig,
  dispatchClearOnlyErrorMessages: errorMessagesActions.clearOnlyErrorMessages,
  dispatchTryAgainClicked: errorMessagesActions.tryAgainClicked,
};

export const ConnectedWithHeadlineBackButton = (title, defaultPrevPath) => (Component) =>
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withHeadlineBackButton(title, defaultPrevPath)(Component));
